export const WORKSPACE_STORAGE_KEY = 'selectedWorkspace';
